// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TOY3V","fullWidth":"styles_fullWidth__213lI","graphics":"styles_graphics__wg_I5"};